import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const ProvisionalFuelMissionService = {

    async getFuelMissions(filter){
        try{
            const queryParams = new URLSearchParams({
            state: filter.state || "",
            reference: filter.reference || "",
            destination: filter.destination || "",
            debut: filter.debut || "",
            fin: filter.fin || "",
            title: filter.title || ""
            });
            const result = await axios.get(`${apiUrl}/ProvisionalFuelMission/?` + queryParams.toString());
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async findDetailsAgendaTimeSheet(agendaId, transportId = 0){
       try{
            const result = await axios.get(`${apiUrl}/ProvisionalFuelMission/detailsAgendaTimeSheet/` + agendaId + "/" + transportId);
            if (result) {
                return result.data;
            }
        
       } catch (err){
            if (err.response) {
                return err.response.data;
            }
       }
    },

    async saveTimeSheetMission(timeSheetMission){
        try{
            const result = await axios.post(`${apiUrl}/ProvisionalFuelMission/`, timeSheetMission);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async updateStateTimeSheetMission(missionId, state){
        try{
            const result = await axios.post(`${apiUrl}/ProvisionalFuelMission/updateState` , {
                mission_planning_id: missionId,
                state: state
            });
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async getAgendaData(agendaId){
        try{
            const result = await axios.get(`${apiUrl}/ProvisionalFuelMission/agenda/` + agendaId);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async getTimesheetsVehicleList(){
        try{
            const result = await axios.get(`${apiUrl}/ProvisionalFuelMission/timesheetsVehicleList`);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async getTimesheetVehicleDetails(transportId, timesheetId = 0){
        try{
            const result = await axios.get(`${apiUrl}/ProvisionalFuelMission/timesheetVehicleDetails/?transportId=`+transportId+"&timesheetId="+timesheetId);
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async generateTimesheetVehicle(transportId, missionTimesheetId) {
        try {
            const response = await axios.get(`${apiUrl}/ProvisionalFuelMission/generateTimesheetVehicle?transportId=`+transportId+`&timesheetId=`+missionTimesheetId, {
                responseType: 'blob',
            });
            return response;
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async sendProvisionalFuelToConfirm(missionId, agendaId = 0) {
        try {
            const response = await axios.get(`${apiUrl}/ProvisionalFuelMission/sendProvisonalfuelToConfirm/` + missionId + "/" + agendaId );
            if( response) {
                return response.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async kilometersDestinations(agenda_id = 0, timesheet_id = 0) {
        try {
            const response = await axios.get(`${apiUrl}/KilometersMission/kilometersDestinations/` + agenda_id + "/" + timesheet_id
            );
            if (response) {
                return response.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async getTimesheetById(timesheet_id) {
        try {
            const response = await axios.get(`${apiUrl}/ProvisionalFuelMission/getTimesheetById/` + timesheet_id);
            if (response) {
                return response.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async fuelProvisionnalByTransport(
        transport_id,
        mission_rent_id = null,
        provisional_fuel_id = null
    ) {
        try {
            const queryParams = new URLSearchParams({
                transport_id,
                mission_rent_id: mission_rent_id ?? "",
            });
            if (provisional_fuel_id) {
                queryParams.set("provisional_fuel_id", provisional_fuel_id);
            }
            const response = await axios.get(
                `${apiUrl}/ProvisionalFuelMission/fuelProvisionnalByTransport/?${queryParams.toString()}`
            );
            if (response) {
                return response.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async confirmFuelProvisionnalMission(payload) {
        try {
            const response = await axios.post(`${apiUrl}/ProvisionalFuelMission/confirmProvisionalFuelMission/`, payload);
            if (response) {
                return response.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },
    async getFuelHistory(agendaId, vehicleId = 0) {
        try {
            const response = await axios.get(`${apiUrl}/ProvisionalFuelMission/history/${agendaId}/${vehicleId}`);
            if (response) {
                return response.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
    },

    async refuseProvisionalFuelMission(provisionalFuelId, observation, missionId = 0, agendaId = 0) {
        try {
            const response = await axios.post(`${apiUrl}/ProvisionalFuelMission/refuseProvisionalFuelMission/`, {
                provisional_fuel_id: provisionalFuelId,
                observation: observation,
                mission_planning_id: missionId,
                mission_planning_agenda_id: agendaId
            });
            if (response) {
                return response.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
        },

    async validateProvisionalFuelMission(provisionalFuelId, missionId = 0, agendaId = 0) {
        try {
            const response = await axios.post(`${apiUrl}/ProvisionalFuelMission/validateProvisionalFuelMission/`, {
                provisional_fuel_id: provisionalFuelId,
                mission_planning_id: missionId,
                mission_planning_agenda_id: agendaId
            });
            if (response) {
                return response.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
        },
    async downloadValidatedProvisionalFuelZip(provisionalFuelId) {
        try {
            const response = await axios.get(
                `${apiUrl}/ProvisionalFuelMission/downloadValidatedProvisionalFuelZip/` + provisionalFuelId,
                { responseType: 'blob' }
            );
            return response.data;
        } catch (err) {
            throw err;
        }
    },
   async downloadProvisionalFuelMissionFile(provisionalFuelId) {
        try {
            const response = await axios.get(`${apiUrl}/ProvisionalFuelMission/downloadProvisionalFuelMissionFile/` + provisionalFuelId, {
                responseType: 'blob',
            });
            return response;
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }   
        }, 
    async getProvisionalFuelMission(provisionalFuelId) {
        try {
            const response = await axios.get(`${apiUrl}/ProvisionalFuelMission/getProvisionalFuelMission/` + provisionalFuelId);
            if (response) {
                return response.data;
            }
        } catch (err) {
            if (err.response) {
                return err.response.data;
            }
        }
     },   
     async getProvisionalFuelMissionAccount(filter){
        try{
            const queryParams = new URLSearchParams({
            state: filter.state || "",
            reference: filter.reference || "",
            destination: filter.destination || "",
            debut: filter.debut || "",
            fin: filter.fin || "",
            title: filter.title || ""
            });
            const result = await axios.get(`${apiUrl}/ProvisionalFuelMission/provisionalFuelAccount?` + queryParams.toString());
            if (result) {
                return result.data;
            }
        } catch (err){
            if (err.response) {
                return err.response.data;
            }
        }
     } 
};

export default ProvisionalFuelMissionService;
